import { useState, createContext } from "react";

export const NavegationQuestionContext = createContext();

export default function NavegationQuestionProvider({ children }) {
    const [enablePassQuestion, setEnablePassQuestion] = useState(true);

    const onChangeEnablePassQuestion = (enabled) => {
        setEnablePassQuestion(enabled);
    }

    return (
        <NavegationQuestionContext.Provider value={{onChangeEnablePassQuestion, enablePassQuestion}}>
            {children}
        </NavegationQuestionContext.Provider>
    )
}